import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const handleUpdateVoiceFavorite = async (characterID, ID, favorite) => {
  try {
    const res = await axiosInstance.post(
      API_ROUTES.Character.favVoice
        .replace(':character_id', characterID)
        .replace(':id', ID),
      {
        favorite
      }
    )
    return res.data
  } catch (e) {
    console.log(e)
  }
}
